import React from 'react';
import './AboutUsSection.css';
import teamworkImage from '../assets/teamwork.png'; 
import smallGraphic from '../assets/small-graphic.png'; 

const AboutUsSection = () => {
  return (
    <section className="about-us-section">
      <div className="container about-us-grid">
        <div className="about-us-image-container">
          <img src={teamworkImage} alt="Person working on laptop" className="about-us-img" />
        
          <img src={smallGraphic} alt="Small decorative graphic" className="about-us-small-graphic" />
        </div>
        <div className="about-us-text-content">
          <p className="about-us-highlight">
            Ser el aliado tecnológico y creativo que transforme más ideas en negocios sostenibles en México y LATAM.
          </p>
          <p>
            Entendemos que el diseño no es solo estética, sino una poderosa herramienta para comunicar valores,
            conectar con tu audiencia y construir una identidad sólida.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;